



















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import NavigationLink from './NavigationLink.vue';

@Component({
  components: {
    NavigationLink,
  },
})
export default class SubNavigation extends Vue {
  public showNav = false;

  @Watch('$route', { immediate: true, deep: true })
  onUrlChange(): void {
    if ((window.location.hash.replace('#', '') === 'property')) {
      this.showNav = true;
    } else {
      this.showNav = false;
    }
  }
}
